<template>
  <div class="md:tw-flex tw-items-start tw-h-auto">
    <EventContent :contenu="event"/>
    <EventSide :contenu="event"/>
  </div>
</template>

<script>
import EventSide from "./Details/EventSide";
import EventContent from "./Details/EventContent";
export default {
  name: "EventDetail",
  components: {EventContent, EventSide},
  props : ['event' , 'popup']
}
</script>

<style lang="scss" scoped>

</style>